import type { GetApiShipmentsData, ShipmentStatus } from '@/api';

/*
 * Состояние «Моих задач» - в search params маршрута: клиент, чип статуса,
 * страница. В URL только то, что отличается от умолчания.
 */

export const PAGE_SIZE = 10;

/** Чипы статусов - статусы задач в порядке жизненного цикла (сервер: ShipmentTasks). */
export const TASK_STATUSES: ReadonlyArray<ShipmentStatus> = [
  'Planned1',
  'Planned2',
  'Agreed',
  'Delivery',
  'Payment',
];

export interface TasksSearch {
  /** Партнёр-клиент; нет - все клиенты. */
  partner?: string;
  /** Чип статуса; нет - «Все». */
  status?: ShipmentStatus;
  page?: number;
}

export interface ResolvedTasksSearch {
  partner: string | undefined;
  status: ShipmentStatus | undefined;
  page: number;
}

const isTaskStatus = (value: unknown): value is ShipmentStatus =>
  (TASK_STATUSES as ReadonlyArray<unknown>).includes(value);

export const validateTasksSearch = (
  raw: Record<string, unknown>,
): TasksSearch => {
  const result: TasksSearch = {};

  if (typeof raw.partner === 'string' && raw.partner !== '')
    result.partner = raw.partner;

  if (isTaskStatus(raw.status)) result.status = raw.status;

  const page = Number(raw.page);
  if (Number.isInteger(page) && page > 1) result.page = page;

  return result;
};

export const resolveTasksSearch = (
  search: TasksSearch,
): ResolvedTasksSearch => ({
  partner: search.partner,
  status: search.status,
  page: search.page ?? 1,
});

/** Задачи - самые срочные сверху: ближайшая плановая дата первой. */
export const toTasksQuery = (
  resolved: ResolvedTasksSearch,
): NonNullable<GetApiShipmentsData['query']> => {
  const query: NonNullable<GetApiShipmentsData['query']> = {
    IsTask: true,
    PageNumber: resolved.page,
    PageSize: PAGE_SIZE,
    Sort: 'plannedDate:asc',
  };

  if (resolved.partner !== undefined) query.PartnerId = resolved.partner;
  if (resolved.status !== undefined) query.Statuses = [resolved.status];

  return query;
};
